<script module lang="ts">
  import type { TextCardStoryblokProps } from './text-card.types';
  import type { Snippet } from 'svelte';

  export interface TextCardProps extends TextCardStoryblokProps {
    children?: Snippet;
  }
</script>

<script lang="ts">
  import { Card, CardHeader, CardContent, CardFooter } from '@agapi/ui/card';
  import { Badge } from '@agapi/ui/badge';
  import { storyblokEditable, StoryblokComponent } from '@storyblok/svelte';
  import { css } from '@agapi/ui/panda/css';

  const { blok }: TextCardProps = $props();
</script>

<Card
  use={[[storyblokEditable, blok]]}
  spacing="normal"
  css={{ height: 'full' }}
>
  <CardHeader css={{ gap: '3' }}>
    {#if blok.badge}
      <Badge colorVariant="primary.subdued">{blok.badge}</Badge>
    {/if}
    <h3 class={css({ textStyle: 'h3', maxWidth: '100%' })}>{blok.title}</h3>
  </CardHeader>

  <CardContent>

  </CardContent>

  {#if blok.button?.[0]}
    <CardFooter>
      <StoryblokComponent blok={blok.button[0]} />
    </CardFooter>
  {/if}
</Card>
